import React, { Component } from "react";
import { render } from 'react-dom';
import { Tabs, TabList, Tab, TabPanels, TabPanel, Button } from '@carbon/react';
import "../container/testimonials.css";
import Boy from '../img/boy.png';
import BoyTwo from '../img/boy2.png';

import scholars1 from '../img/scholars-1.jpg';
import scholars2 from '../img/scholars-2.jpg';
import scholars3 from '../img/scholars-3.jpg';
import scholars4 from '../img/scholars-4.jpg';
import scholars5 from '../img/scholars-5.jpg';
import scholars6 from '../img/scholars-6.jpg';
import scholars7 from '../img/scholars-7.jpg';
import scholars8 from '../img/scholars-8.jpg';
import scholars9 from '../img/scholars-9.jpg';
import scholars10 from '../img/scholars-10.jpg';
import scholars11 from '../img/scholars-11.jpg';
import scholars12 from '../img/scholars-12.jpg';
import scholars13 from '../img/scholars-13.jpg';
import scholars14 from '../img/scholars-14.jpg';

export default class STUDENTTESTIMONIALSsuccess extends Component {

    render() {

        return (
            <div className="our-student-success-new our-student-success" style={{ width: '100%' }}>
                <Tabs>
                    <div className="container">
                        <TabList aria-label="List of tabs">
                            <Tab>
                                <img src={scholars1} />
                            </Tab>
                            <Tab>
                                <img src={scholars2} />
                            </Tab>
                            <Tab>
                                <img src={scholars3} />
                            </Tab>
                            <Tab>
                                <img src={scholars4} />
                            </Tab>
                            <Tab>
                                <img src={scholars5} />
                            </Tab>
                            <Tab>
                                <img src={scholars6} />
                            </Tab>
                            <Tab>
                                <img src={scholars7} />
                            </Tab>
                            <Tab>
                                <img src={scholars8} />
                            </Tab>
                            <Tab>
                                <img src={scholars9} />
                            </Tab>
                            <Tab>
                                <img src={scholars10} />
                            </Tab>
                            <Tab>
                                <img src={scholars11} />
                            </Tab>
                            {/*<Tab>
                                <img src={scholars12} />
                            </Tab>
                            <Tab>
                                <img src={scholars13} />
                            </Tab>
                            <Tab>
                                <img src={scholars14} />
        </Tab>*/}
                        </TabList>
                    </div>
                    <TabPanels>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Navya Agarwal</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Indus International School, Bangalore</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptances</h4>
                                                        <p>Stanford, Oxford, Brown, Northwestern</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>South Asian Studies</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest</h4>
                                                        <p>History, Art, South Asian Studies, Culture</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combine those interests</h4>
                                                <p>Navya's mission was to advocate for human rights across the globe (with lessons from Nazi Germany to Partitioned India), empowering downtrodden communities through art to promote expression, reconciliation, and healing from ugly chapters in history.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact</h4>
                                                <p><b>Artist/Founder: Project Limitless</b> (2018-2021)<br />
                                                    Painted 16 murals in the homes of marginalized people to give them ownership of their narratives and transform their spaces. Organized a team of 250 volunteers across India. She also launched a clothing line of mural designs and raised 50,000 INR toward COVID relief for communities involved.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>
                                                    Authored a study on propaganda and protest art in Theresienstadt Ghetto that was published in the Journal of Student Research. Assisted Trinity University Professor Victoria Aaron's artwork analysis for a book on female holocaust artists.

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Samara Mohan</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Metro International, Delhi</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance</h4>
                                                        <p>Barnard</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Major Applied for
                                                        </h4>
                                                        <p>Gender and Sexuality
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest
                                                        </h4>
                                                        <p>LGBTQ Activism, Economics, Law and Human Rights
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combine those interests
                                                </h4>
                                                <p>
                                                    Samara Mohan’s capstone was The Light-Up Project, an impact-oriented business where she designed and sold handmade jewelry, lamps, and resin decorations to raise Rs 210,000. With these profits, she covered peripheral costs for medical supplies, surgeries, and check-ups of low-income families camping at AIIMS.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>

                                                <p>
                                                    She led a team of 100 to help 500+ teens struggling with mental health challenges by writing articles and conducting seminars.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>
                                                    Conducted official research on the “Perceptions of Indian Residents Towards Factors Influencing Adoption in India”

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Anushka Khetawat </h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Welham Girls School</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance</h4>
                                                        <p>Barnard</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Major Applied </h4>
                                                        <p>Comparative Literature, Poetry and Literature</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combine those interests</h4>
                                                <p>
                                                    Strategic Profile Development that showed the scholar's multifaceted contribution to their school community as they were in a boarding school. Harnessed scholar's poetic ability to show their potential as literature applicant in essays and activities. Facilitated Sitare internship to strengthen community service angle.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact</h4>
                                                <p>Started Spoken Word Poetry in school for self-expression
                                                    Research - N/A
                                                </p>

                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research element</h4>
                                                <p>
                                                    Authored a study on propaganda and protest art in Theresienstadt Ghetto. Published in JSR. Assisted Prof. Victoria Aaron's (Trinity University) artwork analysis for a book on female holocaust artists.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Nikita Daga</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Canadian International School, Bangalore</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance</h4>
                                                        <p>Duke, UCLA</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Major Applied for</h4>
                                                        <p>Economics</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest</h4>
                                                        <p>Behavioral economics, financial literacy, women's empowerment </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena Combine those interests</h4>
                                                <p>
                                                    Nikita interviewed women across twelve Indian states, analyzing the obstacles hindering their financial independence and compiled them in a book titled “Blooming.” She used internships at Kivi Capital and Florence capital to deepen her engagement with economics and finance.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>
                                                    Conducted financial literacy workshops for women across social classes.
                                                </p>

                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>
                                                    Published a research paper on the factors that influence Indian women's financial independence

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Akshal Jain</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>GEMS Wellington, Dubai</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptances</h4>
                                                        <p>Duke, UCLA, University of Michigan, Georgia Tech</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>Computer Science</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest</h4>
                                                        <p>Computer science, politics, linguistics</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combined those interests</h4>
                                                <p>
                                                    Akshal’s profile integrated his passion for public speaking and computer science through an NLP analysis of Indian political speeches. As Head Boy, international debate champion, and a youth activist, he combined his interests in a clear theme and applied with the strategic major of politics (instead of CS) to optimize his likelihood of admission.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>
                                                    Established his own vision care non-profit called Eyetiative that collected 600+ glasses via 5 global chapters. He organized free check-up camps, providing vision care to 500+ underprivileged children in India. </p>

                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>
                                                    Analyzed use of provocative political rhetoric about CAA to manipulate voters using NLP tools. His research was published in the Journal of Student Research.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Maanas Sharma</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>School of Science and Engineering</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptances</h4>
                                                        <p>MIT, Princeton</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>Applied Math</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest</h4>
                                                        <p>Math, data science, public policy, LGBTQ+ activism</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combined those interests</h4>
                                                <p>
                                                    Maanas founded the Journal of Interdisciplinary Public Policy (JIPP), an international journal for diverse and interdisciplinary youth perspectives on policy. He edited and published 9 editions with 100+ student authors across 5 continents. Designed website & social media garnering 100K interactions. He also founded Countermelody: Tunes for LGBTQ+ India During COVID.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>
                                                    Organized live fundraiser concert of 10+ diverse musicians with a reach of 3M. Raised $3.5K to support the unique struggles of trans-Indians in the pandemic. Co-Founder and Program Director of Seeds2STEM. Held annual inquiry-based STEM event for underserved middle school girls.

                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Arnav Pandit</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Shri Ram School, Aravali</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance
                                                        </h4>
                                                        <p>UC Berkeley, Princeton, Imperial
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major
                                                        </h4>
                                                        <p>Materials Science
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest
                                                        </h4>
                                                        <p>Chemistry, Physics, Data, Research
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combined those interests
                                                </h4>
                                                <p>
                                                    Athena identified Arnav as a builder. With his practical approach to the sciences, he loved to take machines apart and put them back together, which did with an entire motorcycle. Using his academic interest in chemicals and machines, founded the Design and Technology Club at his school and spearheaded the establishment of the D&T Lab.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>

                                                <p>
                                                    He was the Head Organizer and Mechanic at Honda Motor Company. Through an internship at Honda Studio, Arnav collaborated with Honda to conduct free maintenance drives, servicing 250+ motorbikes and conducting vocational training course.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research
                                                </h4>
                                                <p>
                                                    He conducted college-level research in the Jawaharlal Nehru University Primary on the Aerodynamics of F1 Car Design; conducted and analyzed surveys on aerodynamics in our daily lives.

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Aryan Dawer
                                                    </h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Modern School, Barakhamba Road
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance
                                                        </h4>
                                                        <p>Dartmouth, Georgia Tech
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major
                                                        </h4>
                                                        <p>Computer Science
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest
                                                        </h4>
                                                        <p>Theater, Psychology, Computer Science
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combined those interests</h4>
                                                <p>
                                                    Empathetic and expressive, Aryan combined his proficiency in computer science with his passion for mental health by creating tools that help neurodivergent people navigate life more easily.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>
                                                    Through his capstone, Project Recognize, he built an Augmented Reality and Machine Learning based emotion recognition tools for children with ASD (including EmoInterpret, attested by internationally certified behavior analyst, Dr. Denise Chua), partnering with 5+ special schools and impacted 2000+ children in 5 countries. He also launched a podcast series called “The ABCs of ASD,” in which he interviewed caregivers and discussed education methods for autistic children.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research element
                                                </h4>
                                                <p>
                                                    Aryan analyzed 29 autism caregivers' views on the efficacy of his app. He created informational videos, coordinated beta-testing with 10 families for 7 days, and collaborated with the Center for Applied Practice in Education to track use by children with ASD.
                                                </p>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Stefano Chiampo</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>United World College of South East Asia (Dover Campus)</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance</h4>
                                                        <p>Tufts (ED)</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>Environmental Science</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest</h4>
                                                        <p>Environmental studies, marine biology, theater, sailing
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How Athena combined those interests
                                                </h4>
                                                <p>
                                                    Stefano synthesized his love for sailing, marine biology, and theater in a strong profile theme by establishing his own aquarium as a teaching tool, leading of team of 25 to inspire environmental sustainability. He was also an experienced sailor and theater performer—these unique hooks helped his essays and profile really stand out.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>

                                                <p>Through an internship at the Ocean Plastic Prevention Accelerator, Stefano analyzed waste management systems of Indonesia and collaborated with startups to arrive at effective techniques of plastic neutralization.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>
                                                    He conducted research on effects of Biophillia-a psychological phenomenon—to aid conservation outreach. His paper was published in Questioz, an International student-led journal for high-school research.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Krish Bansal
                                                    </h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>The Shri Ram School, Moulsari
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptances
                                                        </h4>
                                                        <p>Duke, UCLA, Georgia Tech
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>Computer Science
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest
                                                        </h4>
                                                        <p>Computer science, data science, agriculture
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How Athena combined these interests
                                                </h4>
                                                <p>
                                                    With his thirst for learning and innovation, Krish’s profile centered around using computer science to transform the future of farming techniques and Indian agriculture.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>
                                                    Krish developed a hybrid Gauss Newton Optimization Algorithm - Long Short Term Memory machine learning model to predict the crop yield of 124 different varieties of crops, which is now deployed as a web application and has assisted 47 farmers (so far).
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research element
                                                </h4>
                                                <p>
                                                    He authored a research paper titled "Crop yield prediction using a hybrid Long Short-Term Memory-Gauss Newton optimization algorithm" that was published in Lattice - The Machine Learning Journal.

                                                </p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Shiv Kampani</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Dhirubhai Ambani International School
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance
                                                        </h4>
                                                        <p>Columbia (ED)
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major
                                                        </h4>
                                                        <p>Computer Science</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest

                                                        </h4>
                                                        <p>Computer science, NLP, Robotics, Entrepreneurship
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How Athena combined those interests
                                                </h4>
                                                <p>
                                                    Shiv founded Scatter Innovations, a successful business venture. He built and programmed three versions of SENSAFE, a patent-pending IoT-enabled gas leak detector. He also programmed FireEscape and illustrated safety guide and developed FireEscape, an educational video game that raised awareness among students from 200+ schools. His Pipe Cleaner robot that could address manual scavenging earned him first prize (~$1700) at the India Innovation Challenge.

                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact
                                                </h4>
                                                <p>Shiv founded HelpOut to support education, healthcare, and water supply of Ladiwali (village). Programmed an online LMS for students from Deepalaya (NGO)
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research </h4>
                                                <p>Under Prof. Carlotta Berry, he built and programmed sensor-equipped robots able to communicate and locate survivors during search-and-rescue operations</p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        {/*<TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Abhivir Singh
                                                    </h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Delhi Public School, Faridabad
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptances
                                                        </h4>
                                                        <p>
                                                            University of Cambridge, Imperial College, London

                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major</h4>
                                                        <p>Engineering</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of interest
                                                        </h4>
                                                        <p>CS, Software design
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combined those interests
                                                </h4>
                                                <p>
                                                    Athena helped Abhivir build an e-Gurudwara app, a location-based service system that could identify where langar was being distributed.
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Peehu Agrawal
                                                    </h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>The Mother's International School
                                                        </p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance
                                                        </h4>
                                                        <p>Stanford</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Intended Major
                                                        </h4>
                                                        <p>Undeclared</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of interest
                                                        </h4>
                                                        <p>Literature, Sociology, Gender Studies
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How Athena combined those interests
                                                </h4>
                                                <p>
                                                    Athena ideated a project that integrated her literary interests with her socio-political consciousness. The project involved the preservation of oral literary and cultural traditions by creating a Youtube channel called Suno Story, where she recorded and posted oral stories about local heroes. Athena also helped ideate historical web novels, a relatively underexplored genre.
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="testimonials-all-page-align">
                                <div className="our-student-success-new2">
                                    <div className="testimonials-all-page-align-middle">
                                        <div className="testimonials-all-page-align-middle-left">
                                            <div className="testimonials-all-page-align-middle-left2">
                                                <div className="testimonials-all-page-align-middle-left3">
                                                    <h2>Ria Bhatnagar</h2>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>School</h4>
                                                        <p>Indus International, Bangalore</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Grade </h4>
                                                        <p>41/45 Predicted</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Final College Acceptance</h4>
                                                        <p>Brown, UCLA, UC Berkeley</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Major Applied for</h4>
                                                        <p>Music, Gender and sexuality studies, Undeclared</p>
                                                    </div>
                                                    <div className="tab-new-frame-middle">
                                                        <h4>Areas of Interest </h4>
                                                        <p>
                                                            Music (Contemporary Voice), Literature, Song Writing, make-up, women empowerment
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonials-all-page-align-middle-right">
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>How did Athena combine those interests</h4>
                                                <p>
                                                    Wrote a poetry book- Sanctuary. Held concerts for mental health and covid relief at school and outside. Gift a Song initiative for palliative care- every donor was dedicated a cover of a song of their choice. Internship with Florence- wrote a Music Anthem for a company that provides financial independence (loans) to women-led small-scale businesses.
                                                </p>
                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Social Impact</h4>
                                                <p>Contributed towards causes for children at an orphanage, at an old age home, for her peers and women</p>

                                            </div>
                                            <div className="testimonials-all-page-align-middle-right-heading-new">
                                                <h4>Research element</h4>
                                                <p>
                                                    Researched the male gaze and objectification of women in Bollywood over 4 decades.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
        </TabPanel>*/}
                    </TabPanels>
                </Tabs>
            </div>
        )
    }
}